import React, { useMemo, memo } from 'react';
import Button from "@material-ui/core/Button";
import { makeStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import { useForm, Controller } from "react-hook-form";

import * as RemindersApi from "../../../Common/Apis/RemindersApi";
import { ISubCategory } from '../store/ReminderStore';
import RmDialog from '../../../Common/UI/Dialog/RmDialog';
import { useSpinner } from '../../../../core/contexts/SpinnerContext';
import { useNotification } from "../../../../core/contexts/NotificationContext";

interface IProps {
  item: ISubCategory | undefined;
  onClose: (isRefresh: boolean) => void
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },

}));


const EditSubCategoryDialog = ({ item, onClose }: IProps) => {

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      txtId: item?.Id ?? '',
      txtName: item?.Name ?? '',
    }
  });

  const { showSuccess } = useNotification();
  const { setSpinner } = useSpinner();

  const muiClasses = useStyles();


  const onSubmit = async (data: any) => {
    try {

      setSpinner(true);

      if (item && item.Id !== "") {
        await RemindersApi.editSubCategory(item.Id, data.txtName);
      }
      else {
        await RemindersApi.addSubCategory(data.txtName);
      }


      showSuccess("success", "sucessfully saved", "", 3000, null);
      onClose(true);
    }
    catch (err) {
      console.log('err', err);
    }

    setSpinner(false);
  };


  const footerAction = useMemo(() => (
    <>
      <div className={muiClasses.wrapper}>
        <Button
          className="mb-3"
          style={{ fontWeight: "600" }}
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          color="primary"
        >
          Save
        </Button>
      </div>
    </>
  ), []);

  return (
    <RmDialog
      title="Subcategory"
      onClose={() => { onClose(false); }}
      footerActions={footerAction}
    >
      <form onSubmit={handleSubmit(onSubmit)}>

        <div className="modal-content model-dialog">
          <div className="modal-body  pt-0 pb-0">
            {
              item && item.Id !== "" &&
              <div className="row mt-3">
                <div className="col-12">
                  <div className="p-number">
                    <Controller
                      name="txtId"
                      rules={{ required: true }}
                      control={control}
                      render={({ field }) =>
                        <TextField
                          {...field}
                          style={{ width: "100%" }}
                          label=""
                          variant="outlined"
                          size="small"
                          helperText={""}
                          inputProps={
                            { readOnly: true, }
                          }
                        />}
                    />
                    <span className="p-num-span mr-2">
                      ID
                    </span>

                  </div>
                </div>
              </div>
            }
            <div className="row mt-3 mb-5">
              <div className="col-12">
                <div className="p-number">
                  <Controller
                    name="txtName"
                    rules={{ required: true }}
                    control={control}
                    render={({ field }) =>
                      <TextField
                        {...field}
                        style={{ width: "100%" }}
                        label=""
                        variant="outlined"
                        size="small"
                        error={errors.txtName ? true : false}
                        helperText={""}
                      />}
                  />
                  <span className="p-num-span mr-2">
                    Name
                  </span>
                  {errors.txtName &&
                    <p className="text-danger2">should not be blank</p>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </RmDialog >
  );
};

export default memo(EditSubCategoryDialog);